import { getAndFormatLoginData } from '@services/auth/auth.services';
import { updateAuthHeader } from '@services/axios';
import { IGetUserPlatformsDataResponse } from '@services/users/users.services.type';
import useLogout from '@store/userStore/hooks/useLogout';
import { EUserContextMessagesKey } from '@store/userStore/userStore.enum';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sendMessage } from 'react-message-event';
import { userKeys } from 'src/apis/queries/queriesKeys';

const useLoginMutation = () => {
	const queryClient = useQueryClient();
	const { logout } = useLogout();

	const { mutate, ...mutationResult } = useMutation({
		mutationFn: (accessToken: string) => getAndFormatLoginData(accessToken),
		onSuccess: (data) => {
			const dataWithoutGhAppState = { ...data };
			delete dataWithoutGhAppState.githubAppState;

			queryClient.setQueryData(userKeys.all, data);
			queryClient.setQueryData(
				userKeys.platforms(data.userId),
				(prevUserPlatformsData?: IGetUserPlatformsDataResponse) => {
					// if the updater function receives undefined as input, we return undefined to bail out of the update
					if (!prevUserPlatformsData) return undefined;

					return {
						...prevUserPlatformsData,
						github: data.username,
						githubAppState: data.githubAppState
					};
				}
			);

			updateAuthHeader(data.jwt);

			setTimeout(() => {
				sendMessage({ key: EUserContextMessagesKey.login });
				if (!!window.opener) window.close();
			}, 10);
		},
		onError: (error) => {
			console.error('useLoginMutation', error);
			logout();
		}
	});

	return { login: mutate, ...mutationResult };
};

export { useLoginMutation };
